import { Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import { TextStylesFontTab } from "modules/agency-settings/screens/branding/components/font-tabs/text-styles-font-tab";
import { UploadedFontsTab } from "modules/agency-settings/screens/branding/components/font-tabs/uploaded-fonts-tab";

type FontTabsProps = {
  setIsUploadFontModalOpen: (isOpen: boolean) => void;
};

export function FontTabs({ setIsUploadFontModalOpen }: FontTabsProps) {
  return (
    <Tabs variant={"line"} colorScheme={"gray"}>
      <TabList>
        <Tab>Text styles</Tab>
        <Tab>Uploaded fonts</Tab>
      </TabList>
      <TabPanels>
        <TabPanel display={"flex"} flexDir={"column"} gap={6}>
          <TextStylesFontTab />
        </TabPanel>
        <TabPanel>
          <UploadedFontsTab
            setIsUploadFontModalOpen={setIsUploadFontModalOpen}
          />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
}
